import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class UserService {
  userDocType: string = '';
  userDocNumber: string = '';
  userProfile: any = null;
  
  constructor(private http: HttpClient) {}
  
  getUserInfo(): Observable<any> {
  const cachedUser = sessionStorage.getItem('user_info');
  if (cachedUser) {
    return of(JSON.parse(cachedUser)); // Retorna la info almacenada sin hacer la petición
  }

  const headers = new HttpHeaders({
    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/x-www-form-urlencoded',
  });

  return this.http.post(environment.userInfoUrl, {}, { headers }).pipe(
    tap((response) => {
      sessionStorage.setItem('user_info', JSON.stringify(response)); // Guarda la respuesta
    })
  );
}
  

  getEntityByDocument(docNumber: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      'Content-Type': 'application/json',
      'entity-doc-type': 'NIT',
      'entity-doc-number': docNumber
    });
  
    return this.http.get<any>(environment.entityByDocumentUrl, { headers });
  }

  getHistoryDocument(): Observable<any> {
    return new Observable<any>((observer) => {
      this.getUserInfo().subscribe(
        (data) => {
          this.userDocType = data['custom:tipoDoc'];
          this.userDocNumber = data['custom:numeroDoc'];
          const idToken = localStorage.getItem('id_token');
          const headers = new HttpHeaders({
            'message-id': this.generateUUID(),
            'user-doc-type': this.userDocType,
            'user-doc-number': this.userDocNumber,
            'Authorization': `Bearer ${idToken}`,
          });
  
          this.http.get<any>(environment.documentByUserUrl, { headers }).subscribe(
            (response) => {
              observer.next(response.generatedDocuments || []);
              observer.complete();
            },
            (error) => {
              observer.error('Error al obtener los documentos: ' + error);
            }
          );
        },
        (error) => {
          observer.error('Error al obtener la información del usuario: ' + error);
        }
      );
    });
  }

  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }


  updateUser(data: any, token: string, docType: string, docNumber: string): Observable<any>  {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'user-doc-type': docType,
      'user-doc-number': docNumber,
      'Authorization': `Bearer ${token}`
    });

    return this.http.put<any>(environment.userUrl, data, { headers });
  }
  
}
